export default "__VITE_ASSET__DhwIMxW7__"